import EmailLookupModal from 'components/GlobalModals/EmailLookupModal/EmailLookupModal';
import { withEmailLookupModalProps } from 'viewModel/globalModals/emailLookupModal/withEmailLookupModalProps';

export default withEmailLookupModalProps(EmailLookupModal);
